import { Stack, Text, Title } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { useMantineTheme } from '@mantine/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'

import RootButton from '../Buttons/RootButton'
import Loading from '../Loading'

interface SyncingAirdropProps {
  discord?: boolean
  back?: () => void
}

const SyncingAirdrop: React.FC<SyncingAirdropProps> = ({ discord = false, back }) => {
  const theme = useMantineTheme()
  const { t } = useTranslation()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  return (
    <Stack style={{ gap: '30px' }}>
      <Title order={isMobile ? 3 : 2}>
        {t('components.airdrop.interactLoading', 'Syncing with airdrop bot...')}
      </Title>
      <Text style={{ fontSize: 14 }}>
        {discord
          ? t(
              'components.airdrop.loadingDescription',
              'The airdrop bot is searching for activity on your linked LAMINA1 and Discord accounts. Be patient as it sends this information back to to Hub and tabulates your total rewards.'
            )
          : t(
              'components.airdrop.loading',
              'Checking for platform rewards linked to your account...'
            )}
      </Text>
      <Loading size="110px" />
      {discord && (
        <Stack style={{ flexDirection: 'row' }}>
          <RootButton secondary expand onClick={back}>
            {t('buttons.back', 'Back')}
          </RootButton>
        </Stack>
      )}
    </Stack>
  )
}

export default SyncingAirdrop
